/* eslint-disable */

export default {
  name: "BolideLoader",

  data() {
    const messages = [
      "Loading insights",
      "Preparing dashboard",
      "Gathering metrics",
      "Building your view",
      "Syncing data"
    ];

    return ({
      loader_message: messages[Math.floor(Math.random() * messages.length)]
    });
  }
};
